export const FETCH_LOCATION_UNITS_REQUEST = 'FETCH_LOCATION_UNITS_REQUEST'
export const SET_LOCATION_UNITS = 'SET_LOCATION_UNITS'
